import * as React from 'react';
import { ApTooltip, ApIcon, colors } from '@alixpartners/ui-components';

const wrapperStyles = {
	cursor: 'pointer',
	display: 'inline-flex',
	position: 'relative',
	top: 6,
	marginLeft: 6,
};

export const InfoTooltip = ({ message, ...rest }) => (
	<ApTooltip placement="top" message={message} {...rest}>
		<div style={wrapperStyles}>
			<ApIcon iconName="baseline_help_outline" iconColor={colors.black} />
		</div>
	</ApTooltip>
);
